import React from "react";
import {
  Button,
  HStack,
  IconButton,
  StackDivider,
  Text,
  VStack,
} from "@chakra-ui/react";
import { IoIosCloseCircleOutline } from "react-icons/io";

const DeviceCard = ({
  index,
  data,
  decrementHandler,
  incrementHandler,
  removeDataHandler,
}) => {
  return (
    <HStack
      w={"full"}
      bg={"#FCFCFC"}
      borderColor={"#EFEFEF"}
      borderWidth={1}
      borderRadius={4}
      px={5}
      py={2}
      align={"center"}
      justify={"space-between"}
      divider={<StackDivider borderColor="#EFEFEF" />}
      gap={4}
    >
      <Text color={"#000"} fontSize={13} fontWeight={"normal"}>
        {index}
      </Text>
      <HStack w={"full"} align={"center"} justify={"space-between"} gap={2}>
        <VStack align={"flex-start"} spacing={0}>
          <Text color={"#000"} fontSize={13} fontWeight={"medium"}>
            {data?.name ? data.name : data.deviceName}
          </Text>
          <HStack spacing={10}>
            <Text color={"#000"} fontSize={13} fontWeight={"normal"}>
              {"Нэгж үнэ: "}
              <Text as={"span"} fontWeight={"medium"}>
                {data.price.toLocaleString() + "₮"}
              </Text>
            </Text>
            {data?.stock && (
              <Text color={"#000"} fontSize={13} fontWeight={"normal"}>
                {"Нийт үлдэгдэл: "}
                <Text as={"span"} fontWeight={"medium"}>
                  {data.stock + "ш"}
                </Text>
              </Text>
            )}
          </HStack>
        </VStack>
        <HStack align={"center"} justify={"center"} gap={2}>
          <Button
            color={"#000"}
            fontSize={15}
            fontWeight={"medium"}
            onClick={() => decrementHandler(data._id)}
            isDisabled={data.quantity === 1 ? true : false}
          >
            -
          </Button>
          <Text color={"#000"} fontSize={15} fontWeight={"medium"}>
            {data.quantity}
          </Text>
          <Button
            color={"#000"}
            fontSize={15}
            fontWeight={"medium"}
            onClick={() => incrementHandler(data._id)}
            isDisabled={data.quantity === data.stock ? true : false}
          >
            +
          </Button>
        </HStack>
      </HStack>
      <IconButton
        transition={"ease-in-out .3s"}
        bg={"transparent"}
        color={"#f00"}
        borderWidth={1}
        borderColor={"transparent"}
        _hover={{
          borderColor: "#f00",
          bg: "#ffdcdc",
          color: "#f00",
        }}
        _focus={{
          outline: "none",
        }}
        icon={<IoIosCloseCircleOutline size={20} />}
        onClick={() => removeDataHandler(data)}
      />
    </HStack>
  );
};

export default DeviceCard;
